import createIcon from '../../createIcon';

/**
 * @component @name FormatColorFill
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTYgOC45NEw3LjYyIDBMNi4yMSAxLjQxTDguNTkgMy43OUwzLjQ0IDguOTRDMi44NSA5LjUzIDIuODUgMTAuNDggMy40NCAxMS4wNkw4Ljk0IDE2LjU2QzkuMjMgMTYuODUgOS42MiAxNyAxMCAxN0MxMC4zOCAxNyAxMC43NyAxNi44NSAxMS4wNiAxNi41NkwxNi41NiAxMS4wNkMxNy4xNSAxMC40OCAxNy4xNSA5LjUzIDE2LjU2IDguOTRaTTUuMjEgMTBMMTAgNS4yMUwxNC43OSAxMEg1LjIxWk0xOSAxMS41QzE5IDExLjUgMTcgMTMuNjcgMTcgMTVDMTcgMTYuMSAxNy45IDE3IDE5IDE3QzIwLjEgMTcgMjEgMTYuMSAyMSAxNUMyMSAxMy42NyAxOSAxMS41IDE5IDExLjVaTTIgMjBIMjJWMjRIMlYyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatColorFill = createIcon('FormatColorFill', [
  [
    'path',
    {
      d: 'M16.56 8.94L7.62 0L6.21 1.41L8.59 3.79L3.44 8.94C2.85 9.53 2.85 10.48 3.44 11.06L8.94 16.56C9.23 16.85 9.62 17 10 17C10.38 17 10.77 16.85 11.06 16.56L16.56 11.06C17.15 10.48 17.15 9.53 16.56 8.94ZM5.21 10L10 5.21L14.79 10H5.21ZM19 11.5C19 11.5 17 13.67 17 15C17 16.1 17.9 17 19 17C20.1 17 21 16.1 21 15C21 13.67 19 11.5 19 11.5ZM2 20H22V24H2V20Z',
      key: '1cm28s',
    },
  ],
]);

export default FormatColorFill;
